import { axiosInstance } from "../";

export const communitiesJoined = {
	get: (payload?: { q?: string; page?: number; slug?: string }) =>
		axiosInstance().get("/communities/joined", { params: payload }),
};
